import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { TimeSeriesExample } from '../../components/examples/frame-helpers-examples.js';
import { SeriesAPI, TimeSeriesAPI, CounterAPI, IndicatorAPI } from '../../components/api';
export const _frontmatter = {
  "Title": "Time Series, Counter, Indicator"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><inlineCode parentName="p">{`Time Series`}</inlineCode>{` is a `}<a parentName="p" {...{
        "href": "/react-sim/frame-helpers"
      }}>{`frame helper`}</a>{` with which you can plot some changes in your data object during your simulation.`}</p>
    <TimeSeriesExample mdxType="TimeSeriesExample" />
    <p>{`In this example, we are throwing 2 dice 100 times, and we are plotting the average value of the roll during the process.
We are also looking at the distribution of the rolls.`}</p>
    <h2 {...{
      "id": "series-parameter"
    }}>{`Series parameter`}</h2>
    <p><inlineCode parentName="p">{`TimeSeries`}</inlineCode>{`, `}<inlineCode parentName="p">{`Counter`}</inlineCode>{` and `}<inlineCode parentName="p">{`Indicator`}</inlineCode>{` all rely on a parameter called `}<inlineCode parentName="p">{`series`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`TimeSeries`}</inlineCode>{` and `}<inlineCode parentName="p">{`Counter`}</inlineCode>{` can take either an array of series or a single series, `}<inlineCode parentName="p">{`Indicator`}</inlineCode>{` only takes a single series.`}</p>
    <SeriesAPI mdxType="SeriesAPI" />
    <h2 {...{
      "id": "timeseries"
    }}>{`TimeSeries`}</h2>
    <TimeSeriesAPI mdxType="TimeSeriesAPI" />
    <h2 {...{
      "id": "counter"
    }}>{`Counter`}</h2>
    <CounterAPI mdxType="CounterAPI" />
    <h2 {...{
      "id": "indicator"
    }}>{`Indicator`}</h2>
    <IndicatorAPI mdxType="IndicatorAPI" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      